<div class="checkbox" [ngClass]="{ disabled: disabled }">
  <input type="checkbox" [attr.name]="name" [disabled]="disabled" [(ngModel)]="value" [id]="name" />

  <label [for]="name">
    <span class="ml-2"><ng-content></ng-content></span>
  </label>
</div>
